import { Switch } from "antd";
import React, { useState } from 'react';
import { SpotService } from "../../../util/services/spot";
import { showErrorResponse } from "../../../util/varibles/global";
import { IVessel } from "../../../util/varibles/interface";

interface IProps {
    vessel: IVessel
    onSave?(value: boolean): void
}

const ChangeAutoApi: React.FC<IProps> = ({ vessel, onSave }) => {
    const [loading, setLoading] = useState(false);


    const changeAuto = (enable_auto: boolean) => {
        const { id: vessel_id, enable_spot } = vessel;
        if (loading)
            return;
        setLoading(true);
        SpotService.changeSpecialMode({ vessel_id, enable_spot, enable_auto })
            .then(() => {
                onSave?.(enable_auto)
                setLoading(false);
            })
            .catch(error => {
                showErrorResponse('Update failed', error)
                setLoading(false);
            })
    }

    return <Switch
        checkedChildren="On"
        unCheckedChildren="Off"
        value={!!vessel.enable_auto}
        loading={loading}
        onClick={(e) => changeAuto(e)}
    />
};

export default ChangeAutoApi;
